<template>
  <div>
    <AddInvoiceConceptDialog ref="invoiceConceptDialog" :concepts="invoiceForm.concepts" @updateConcepts="updateConcepts" />

    <v-navigation-drawer
      v-model="open"
      :width="$isMobile ? '100%' : '50%'"
      right
      fixed
      :permanent="open"
      hide-overlay
      class="z-index--100 px-2"
      style="overflow: visible;">
      <div class="pa-3 content" style="overflow: auto; height: 100vh;">
        <div v-if="open" class="d-flex">
          <v-btn
            dark
            fab
            small
            outlined
            color="primary"
            class="close mr-3"
            @click="closePanel()"
            style="position: absolute; left: -20px; background-color: #fff; z-index: 100;"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </div>
        <div class="d-flex mt-6">
          <div class="titlePanel primary--text">
            {{ isInvoiceType
              ? $t('income.billing.generateInvoicePanel.titleInvoice')
              : $t('income.billing.generateInvoicePanel.titleOtherInvoice')
            }}
          </div>
        </div>

        <div class="my-4">
          <div>
            <span class="font-weight-bold">
              {{ $t('income.billing.generateInvoicePanel.issuerData.name') }}
            </span>
            {{ issuerData.name }}
          </div>
          <div>
            <span class="font-weight-bold">
              {{ $t('income.billing.generateInvoicePanel.issuerData.address') }}
            </span>
            {{ issuerData.address }}
          </div>
          <div>
            <span class="font-weight-bold">
              {{ $t('income.billing.generateInvoicePanel.issuerData.rfc') }}
            </span>
            {{ issuerData.rfc }}
          </div>
          <div>
            <span class="font-weight-bold">
              {{ $t('income.billing.generateInvoicePanel.issuerData.taxRegime') }}
            </span>
            {{ issuerData.taxRegime }}
          </div>
        </div>
        <div class="gridContainer">
          <v-col cols="12" class="px-0 pb-0">
            <v-row dense>
              <v-col class="col-3 col-md-4">
                <!-- // Todo: make dateMenu component -->
                <!-- <DateMenu
                  :disabled="isInvoiceType && !invoiceForm.issueDate"
                  v-model="issueDateFormatted"
                /> -->
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      rounded
                      readonly
                      :disabled="isInvoiceType && !invoiceForm.issueDate"
                      v-model.lazy="issueDateFormatted"
                      :label="$t('income.billing.generateInvoicePanel.issueDate')"
                      @input="$v.invoiceForm.issueDate.$touch()"
                      @blur="$v.invoiceForm.issueDate.$touch()"
                      :error-messages="issueDateErrors"
                      required
                      class="labelWhiteBg"
                    >
                      <v-icon slot="append" color="#01D28E">
                        mdi-calendar
                      </v-icon>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="$v.invoiceForm.issueDate.$model"
                    @input="dateMenu = false"
                    :first-day-of-week="1"
                    :allowed-dates="allowedDates"
                    show-current
                    reactive
                    scrollable
                    no-title
                    color="primary"
                    class="pt-2"
                    :locale="locale"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="col-3 col-md-4">
                <v-text-field
                  rounded
                  outlined
                  dense
                  :readonly="isInvoiceType && !!invoiceForm.id"
                  :disabled="isInvoiceType && !invoiceForm.id"
                  v-model.lazy="$v.invoiceForm.id.$model"
                  :label="$t('income.billing.generateInvoicePanel.id')"
                  @input="$v.invoiceForm.id.$touch()"
                  @blur="$v.invoiceForm.id.$touch()"
                />
              </v-col>
              <v-col class="col-3 col-md-4">
                <v-text-field
                  rounded
                  outlined
                  dense
                  :readonly="isInvoiceType && !!invoiceForm.series"
                  :disabled="isInvoiceType && !invoiceForm.series"
                  v-model.lazy="$v.invoiceForm.series.$model"
                  :label="$t('income.billing.generateInvoicePanel.series')"
                  @input="$v.invoiceForm.series.$touch()"
                  @blur="$v.invoiceForm.series.$touch()"
                />
              </v-col>
              <v-col class="col-3 col-md-4">
                <v-text-field
                  rounded
                  outlined
                  dense
                  :readonly="isInvoiceType && !!invoiceForm.observations"
                  :disabled="isInvoiceType && !invoiceForm.observations"
                  v-model.lazy="$v.invoiceForm.observations.$model"
                  :label="$t('income.billing.generateInvoicePanel.observations')"
                />
              </v-col>
              <v-col class="col-3 col-md-4">
                <v-select
                  rounded
                  outlined
                  dense
                  item-text="name"
                  item-value="_id"
                  :items="paymentMethods"
                  :readonly="isInvoiceType && !!invoiceForm.paymentForm"
                  :disabled="isInvoiceType && !invoiceForm.paymentMethod"
                  v-model.lazy="$v.invoiceForm.paymentMethod.$model"
                  :label="$t('income.billing.generateInvoicePanel.paymentMethod')"
                  @input="$v.invoiceForm.paymentMethod.$touch()"
                  @blur="$v.invoiceForm.paymentMethod.$touch()"
                  :error-messages="paymentMethodErrors"
                  required
                />
              </v-col>
              <v-col class="col-3 col-md-4">
                <v-text-field
                  rounded
                  outlined
                  dense
                  :readonly="isInvoiceType && !!invoiceForm.paymentConditions"
                  :disabled="isInvoiceType && !invoiceForm.paymentConditions"
                  v-model.lazy="$v.invoiceForm.paymentConditions.$model"
                  :label="$t('income.billing.generateInvoicePanel.paymentConditions')"
                  @input="$v.invoiceForm.paymentConditions.$touch()"
                  @blur="$v.invoiceForm.paymentConditions.$touch()"
                />
              </v-col>
              <v-col class="col-3 col-md-4">
                <v-select
                  rounded
                  outlined
                  dense
                  item-text="name"
                  item-value="satId"
                  :items="paymentForms"
                  :readonly="isInvoiceType && !!invoiceForm.paymentForm"
                  :disabled="isInvoiceType && !invoiceForm.paymentForm"
                  v-model.lazy="$v.invoiceForm.paymentForm.$model"
                  :label="$t('income.billing.generateInvoicePanel.paymentForm')"
                  @input="$v.invoiceForm.paymentForm.$touch()"
                  @blur="$v.invoiceForm.paymentForm.$touch()"
                  :error-messages="paymentFormErrors"
                  required
                />
              </v-col>
              <v-col class="col-3 col-md-4">
                <v-text-field
                  rounded
                  outlined
                  dense
                  :readonly="isInvoiceType && !!invoiceForm.rfc"
                  :disabled="isInvoiceType && !invoiceForm.rfc"
                  v-model.lazy="$v.invoiceForm.rfc.$model"
                  :label="$t('income.billing.generateInvoicePanel.rfc')"
                  @input="$v.invoiceForm.rfc.$touch()"
                  @blur="$v.invoiceForm.rfc.$touch()"
                  :error-messages="rfcErrors"
                  required
                />
              </v-col>
              <v-col class="col-3 col-md-4">
                <v-text-field
                  rounded
                  outlined
                  dense
                  :readonly="isInvoiceType && !!invoiceForm.name"
                  :disabled="isInvoiceType && !invoiceForm.name"
                  v-model.lazy="$v.invoiceForm.name.$model"
                  :label="$t('income.billing.generateInvoicePanel.name')"
                  @input="$v.invoiceForm.name.$touch()"
                  @blur="$v.invoiceForm.name.$touch()"
                  :error-messages="nameErrors"
                  required
                />
              </v-col>
              <v-col class="col-3 col-md-4">
                <v-text-field
                  rounded
                  outlined
                  dense
                  :readonly="isInvoiceType && !!invoiceForm.email"
                  :disabled="isInvoiceType && !invoiceForm.email"
                  v-model.lazy="$v.invoiceForm.email.$model"
                  :label="$t('income.billing.generateInvoicePanel.email')"
                  @input="$v.invoiceForm.email.$touch()"
                  @blur="$v.invoiceForm.email.$touch()"
                  :error-messages="emailErrors"
                />
              </v-col>
              <v-col class="col-3 col-md-4">
                <v-select
                  rounded
                  outlined
                  dense
                  item-text="name"
                  item-value="satId"
                  :items="cfdiUses"
                  :readonly="isInvoiceType && !!invoiceForm.cfdiUse"
                  :disabled="isInvoiceType && !invoiceForm.cfdiUse"
                  v-model.lazy="$v.invoiceForm.cfdiUse.$model"
                  :label="$t('income.billing.generateInvoicePanel.cfdiUse')"
                  @input="$v.invoiceForm.cfdiUse.$touch()"
                  @blur="$v.invoiceForm.cfdiUse.$touch()"
                  :error-messages="cfdiUseErrors"
                  required
                />
              </v-col>
              <v-col class="col-3 col-md-4">
                <v-text-field
                  rounded
                  outlined
                  dense
                  :readonly="isInvoiceType && !!invoiceForm.zipCode"
                  :disabled="isInvoiceType && !invoiceForm.zipCode"
                  v-model.lazy="$v.invoiceForm.zipCode.$model"
                  :label="$t('income.billing.generateInvoicePanel.zipCode')"
                  @input="$v.invoiceForm.zipCode.$touch()"
                  @blur="$v.invoiceForm.zipCode.$touch()"
                  :error-messages="zipCodeErrors"
                  required
                />
              </v-col>
              <v-col class="col-3 col-md-4">
                <v-select
                  rounded
                  outlined
                  dense
                  item-text="name"
                  item-value="_id"
                  :items="noChargeCategories"
                  :readonly="isInvoiceType && !!invoiceForm.category"
                  :disabled="isInvoiceType && !invoiceForm.category"
                  v-model.lazy="$v.invoiceForm.category.$model"
                  :label="$t('income.billing.generateInvoicePanel.category')"
                  @input="$v.invoiceForm.category.$touch()"
                  @blur="$v.invoiceForm.category.$touch()"
                  :error-messages="categoryErrors"
                  required
                />
              </v-col>
              <v-col class="col-3 col-md-4">
                <v-select
                  rounded
                  outlined
                  dense
                  item-text="name"
                  item-value="satId"
                  :items="taxRegimes"
                  :readonly="isInvoiceType && !!invoiceForm.taxRegime"
                  :disabled="isInvoiceType && !invoiceForm.taxRegime"
                  v-model.lazy="$v.invoiceForm.taxRegime.$model"
                  :label="$t('income.billing.generateInvoicePanel.taxRegime')"
                  @input="$v.invoiceForm.taxRegime.$touch()"
                  @blur="$v.invoiceForm.taxRegime.$touch()"
                  :error-messages="taxRegimeErrors"
                  required
                />
              </v-col>
            </v-row>
          </v-col>
        </div>
        <div v-if="isOtherInvoiceType" class="d-flex justify-end">
          <Button @click="openConceptDialog(undefined, billingType)">
            <v-icon>mdi-plus</v-icon>
            {{ $t('income.billing.generateInvoicePanel.buttonAdd') }}
          </Button>
        </div>
        <div>
          <v-data-table
            :loading-text="tableConcepts.loadingText"
            :loading="tableConcepts.loading"
            :headers="tableConcepts.headers"
            :items="indexedInvoiceConcepts"
            :options="tableConcepts.options"
            :no-data-text="tableConcepts.noDataText"
            hide-default-footer
            :class="['table', 'tableConcepts', !isEmpty(conceptsErrors) && 'table--error']"
          >
            <template v-slot:[`header.quantity`]="{ header }">
              <div class="text-right">{{ header.text }}</div>
            </template>
            <template v-slot:[`item.quantity`]="{ item }">
              <div class="text-right">{{ item.quantity }}</div>
            </template>
            <template v-slot:[`item.unit`]="{ item }">
              {{ getUnitName(item.unit) }}
            </template>
            <template v-slot:[`item.productOrService`]="{ item }">
              {{ item.productOrService }}
              <!-- // Todo: get list of products from api service -->
              <!-- {{ getProductOrServiceName(item.productOrService) }} -->
            </template>
            <template v-slot:[`item.description`]="{ item }">
              {{ item.description }}
            </template>
            <template v-slot:[`header.unitImport`]="{ header }">
              <div class="text-right">{{ header.text }}</div>
            </template>
            <template v-slot:[`item.unitImport`]="{ item }">
              {{ formatCurrency(item.unitImport) }}
            </template>
            <template v-slot:[`header.subtotal`]="{ header }">
              <div class="text-right">{{ header.text }}</div>
            </template>
            <template v-slot:[`item.subtotal`]="{ item }">
              {{ formatCurrency(item.subtotal)  }}
            </template>
            <template v-slot:[`header.taxAmount`]="{ header }">
              <div class="text-right">{{ header.text }}</div>
            </template>
            <template v-slot:[`item.taxAmount`]="{ item }">
              {{ formatCurrency(item.taxAmount)  }}
            </template>
            <template v-slot:[`header.total`]="{ header }">
              <div class="text-right">{{ header.text }}</div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex align-center">
                <v-btn icon color="primary" @click="editConcept(item.index)" class="mr-1">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn v-if="isOtherInvoiceType" icon @click="deleteConcept(item.index)">
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </div>
        <div class="d-flex aling-center justify-end py-4" style="flex-grow: 1;">
          <div>
            <table class="totalBox">
              <tbody>
                <tr>
                  <td class="pr-2 text-right font-weight-bold">{{ $t('income.billing.generateInvoicePanel.subtotal') }}</td>
                  <td class="text-right">{{ formatCurrency(subtotal) }}</td>
                </tr>
                <tr>
                  <td class="pr-2 text-right font-weight-bold">{{ $t('income.billing.generateInvoicePanel.tax') }}</td>
                  <td class="text-right">
                    <div>{{ formatCurrency(taxAmount) }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="pr-2 text-right font-weight-bold">{{ $t('income.billing.generateInvoicePanel.total') }}</td>
                  <td>
                    <div class="text-right">{{ formatCurrency(total) }}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="d-flex justify-end mb-2">
          <Button v-if="isInvoiceType" @click="generateGlobalInvoice()" class="blueButton">
            {{ $t('income.billing.generateInvoicePanel.buttonStampEmit') }}
          </Button>
          <div v-else class="d-flex">
            <Button class="mr-2" @click="emitInvoice()">
              {{ $t('income.billing.generateInvoicePanel.buttonEmit') }}
            </Button>
            <Button class="blueButton" @click="emitTaxInvoice()">
              {{ $t('income.billing.generateInvoicePanel.buttonStampEmit') }}
            </Button>
          </div>
        </div>

      </div>
    </v-navigation-drawer>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, email, helpers } from 'vuelidate/lib/validators'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'

import Button from '@/components/elements/Button'
import AddInvoiceConceptDialog from '@/components/modals/AddInvoiceConceptDialog'
import formatCurrency from '@/utils/formatCurrency'
import { TAX_REGIMES, paymentForms, cfdiUses } from '@/utils/constants'
import getLocale from '@/lang/locale'

const EMPTY_INVOICE_VALUES = {
  issueDate: moment(new Date()).format('YYYY-MM-DD'),
  id: '',
  series: '',
  observations: '',
  paymentMethod: 'PUE',
  paymentConditions: '',
  paymentForm: '',
  rfc: '',
  name: '',
  email: '',
  cfdiUse: '',
  zipCode: '',
  category: '',
  taxRegime: '',
  concepts: []
}

const DEFAULT_INVOICE_VALUES = {
  paymentMethod: 'PUE',
  paymentForm: '99',
  rfc: 'XAXX010101000',
  name: 'VENTAS MOSTRADOR',
  cfdiUse: 'G03',
  taxRegime: '601',
  concepts: [
    {
      quantity: 1,
      unit: 'Servicio',
      productOrService: '90101501',
      description: `Venta a público en general de ${moment(new Date()).format('YYYY-MM')}`,
      hasTax: true,
      includesTax: true
    }
  ]
}

const BILLING_TYPES = ['invoice', 'otherInvoices']

const PAYMENT_METHODS = [
  { _id: 'PUE', name: 'PUE' },
  { _id: 'PPD', name: 'PPD' }
]

// Todo: get list of products from api service
// const PRODUCTS_SERVICES_CATALOG = [
//   { clave: '90101501', descripcion: 'Restaurantes' },
//   { clave: '90101232', descripcion: 'Servicio meseros' },
//   { clave: '90101223', descripcion: 'Bar' },
//   { clave: '90101334', descripcion: 'Servicio a domicilio' },
//   { clave: '90101355', descripcion: 'Renta' },
//   { clave: '90101506', descripcion: 'Catering' },
//   { clave: '90101507', descripcion: 'Comidas' }
// ]

const DEFAULT_TAX_RATIO = 0.16

const rfc = helpers.regex('rfc', /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/)

export default {
  name: 'GenerateInvoicePanel',
  emits: ['updateBilling', 'updateOtherInvoices'],
  components: { Button, AddInvoiceConceptDialog },
  mixins: [validationMixin],
  validations: {
    invoiceForm: {
      issueDate: { required },
      id: {},
      series: {},
      observations: {},
      paymentMethod: { required },
      paymentConditions: {},
      paymentForm: { required },
      rfc: { required, rfc },
      name: { required },
      email: { email },
      cfdiUse: { required },
      zipCode: { required },
      category: { required },
      taxRegime: { required },
      concepts: { required, minLength: minLength(1) }
    }
  },
  data () {
    return {
      open: false,
      billingId: null,
      issuerData: {
        name: this.$store.state.currentRestaurant.taxInformation.data.taxName,
        address: this.getAddress(),
        rfc: this.$store.state.currentRestaurant.taxInformation.data.taxId,
        taxRegime: this.getTaxRegimeName(this.$store.state.currentRestaurant.taxInformation.data.fiscalRegime)
      },
      invoiceForm: {
        issueDate: moment(new Date()).format('YYYY-MM-DD'),
        id: '',
        series: '',
        observations: '',
        paymentMethod: 'PUE',
        paymentConditions: '',
        paymentForm: '',
        rfc: '',
        name: '',
        email: '',
        cfdiUse: '',
        zipCode: '',
        category: '',
        taxRegime: '',
        concepts: []
      },
      tableConcepts: {
        loadingText: this.$i18n.t('income.billing.generateInvoicePanel.tableConcepts.loading'),
        loading: false,
        noDataText: this.$i18n.t('income.billing.generateInvoicePanel.tableConcepts.noDataText'),
        headers: [
          { text: this.$i18n.t('income.billing.generateInvoicePanel.tableConcepts.headers.quantity'), value: 'quantity', sortable: false },
          { text: this.$i18n.t('income.billing.generateInvoicePanel.tableConcepts.headers.unit'), value: 'unit', sortable: false },
          { text: this.$i18n.t('income.billing.generateInvoicePanel.tableConcepts.headers.productOrService'), value: 'productOrService', sortable: false },
          { text: this.$i18n.t('income.billing.generateInvoicePanel.tableConcepts.headers.description'), value: 'description', sortable: false },
          { text: this.$i18n.t('income.billing.generateInvoicePanel.tableConcepts.headers.unitImport'), value: 'unitImport', sortable: false },
          { text: this.$i18n.t('income.billing.generateInvoicePanel.tableConcepts.headers.subtotal'), value: 'subtotal', sortable: false },
          { text: this.$i18n.t('income.billing.generateInvoicePanel.tableConcepts.headers.taxImport'), value: 'taxAmount', sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: -1,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      },
      billingType: null,
      cfdiUses,
      paymentForms,
      dateMenu: false,
      overlay: false,
      selectedConcept: {},
      noChargeCategories: []
      // Todo: get list of products from api service
      // productOrServices: [ ...PRODUCTS_SERVICES_CATALOG ]
    }
  },
  watch: {
    open: function (val) {
      if (val) {
        this.loadNoChargeCategories()
      } else {
        this.resetPanel()
      }
    }
  },
  computed: {
    taxRegimes () {
      return [ ...TAX_REGIMES ]
    },
    paymentMethods () {
      return [...PAYMENT_METHODS]
    },
    issueDateErrors () {
      const errors = []
      if (!this.$v.invoiceForm.issueDate.$dirty) return errors
      !this.$v.invoiceForm.issueDate.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.errors.req'))
      return errors
    },
    paymentMethodErrors () {
      const errors = []
      if (!this.$v.invoiceForm.paymentMethod.$dirty) return errors
      !this.$v.invoiceForm.paymentMethod.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.errors.req'))
      return errors
    },
    paymentFormErrors () {
      const errors = []
      if (!this.$v.invoiceForm.paymentForm.$dirty) return errors
      !this.$v.invoiceForm.paymentForm.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.errors.req'))
      return errors
    },
    rfcErrors () {
      const errors = []
      if (!this.$v.invoiceForm.rfc.$dirty) return errors
      !this.$v.invoiceForm.rfc.rfc && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.errors.rfc'))
      !this.$v.invoiceForm.rfc.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.errors.req'))
      return errors
    },
    nameErrors () {
      const errors = []
      if (!this.$v.invoiceForm.name.$dirty) return errors
      !this.$v.invoiceForm.name.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.errors.req'))
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.invoiceForm.email.$dirty) return errors
      !this.$v.invoiceForm.email.email && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.errors.email'))
      return errors
    },
    cfdiUseErrors () {
      const errors = []
      if (!this.$v.invoiceForm.cfdiUse.$dirty) return errors
      !this.$v.invoiceForm.cfdiUse.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.errors.req'))
      return errors
    },
    zipCodeErrors () {
      const errors = []
      if (!this.$v.invoiceForm.zipCode.$dirty) return errors
      !this.$v.invoiceForm.zipCode.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.errors.req'))
      return errors
    },
    categoryErrors () {
      const errors = []
      if (!this.$v.invoiceForm.category.$dirty) return errors
      !this.$v.invoiceForm.category.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.errors.req'))
      return errors
    },
    taxRegimeErrors () {
      const errors = []
      if (!this.$v.invoiceForm.taxRegime.$dirty) return errors
      !this.$v.invoiceForm.taxRegime.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.errors.req'))
      return errors
    },
    conceptsErrors () {
      const errors = []
      if (!this.$v.invoiceForm.concepts.$dirty) return errors
      !this.$v.invoiceForm.concepts.minLength && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.errors.req'))
      !this.$v.invoiceForm.concepts.required && errors.push(this.$i18n.t('income.billing.generateInvoicePanel.errors.req'))
      return errors
    },
    isInvoiceType () {
      return this.billingType === BILLING_TYPES[0]
    },
    isOtherInvoiceType () {
      return this.billingType === BILLING_TYPES[1]
    },
    indexedInvoiceConcepts () {
      return this.invoiceForm.concepts.map((item, index) => {
        item.index = index
        return item
      })
    },
    locale () {
      return getLocale(this.$i18n.locale)
    },
    issueDateFormatted () {
      return this.invoiceForm.issueDate ? this.$moment(this.invoiceForm.issueDate).format('DD/MM/YYYY') : ''
    },
    units () {
      return this.$store.state.login.units.data
    },
    subtotal () {
      const amount = this.invoiceForm.concepts.reduce((acc, item) => Number(acc) + Number(item.subtotal), 0)
      return amount
    },
    taxAmount () {
      const amount = this.invoiceForm.concepts.reduce((acc, item) => Number(acc) + Number(item.taxAmount), 0)
      return amount
    },
    total () {
      return Number(this.subtotal) + Number(this.taxAmount)
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape') this.open = false
    },
    openPanel (posSale) {
      if (posSale) {
        this.billingType = BILLING_TYPES[0]
        this.invoiceForm = { ...this.invoiceForm, ...DEFAULT_INVOICE_VALUES }
        this.billingId = posSale._id
        this.invoiceForm.concepts[0].unitImport = posSale.invoicePosTotal
        // Calculate totals
        this.invoiceForm.concepts[0].subtotal = this.getSubtotal(this.invoiceForm.concepts[0])
        this.invoiceForm.concepts[0].taxAmount = this.getTaxImport(this.invoiceForm.concepts[0])
        this.invoiceForm.concepts[0].total = this.getTotal(this.invoiceForm.concepts[0])

        this.invoiceForm.zipCode = this.getZipCode()
      } else {
        this.billingType = BILLING_TYPES[1]
      }
      this.open = true
    },
    closePanel () {
      this.open = false
    },
    resetInvoiceForm () {
      this.invoiceForm = { ...EMPTY_INVOICE_VALUES }
      this.invoiceForm.concepts = []
      this.$v.invoiceForm.$reset()
    },
    generateGlobalInvoice: async function () {
      this.overlay = true
      const payload = {
        issueDate: this.invoiceForm.issueDate
      }
      try {
        await this.$api.post(`/v1/charges/pos/${this.billingId}/invoice`, payload)
        this.$emit('updateBilling')
        this.closePanel()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    formatCurrency,
    getTaxRegimeName (id) {
      const taxRegime = TAX_REGIMES.find(item => item.satId === id)
      return taxRegime ? taxRegime.name : id
    },
    getPaymentFormName (id) {
      const paymentForm = paymentForms.find(item => item.satId === id)
      return paymentForm ? paymentForm.name : id
    },
    openConceptDialog (concept, billingType) {
      this.$refs.invoiceConceptDialog.openDialog(concept, billingType)
    },
    emitTaxInvoice () {
      this.$v.invoiceForm.$touch()

      if (!this.$v.invoiceForm.$invalid) {
        this.generateTaxInvoice()
      }
    },
    generateTaxInvoice: async function () {
      const payload = {
        invoice: this.getInvoice(),
        stamp: true
      }
      this.overlay = true
      try {
        await this.$api.post(`/v1/charges/income/${this.invoiceForm.category}/invoice`, payload)
        this.$emit('updateOtherInvoices')
        this.closePanel()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    emitInvoice () {
      this.$v.invoiceForm.$touch()

      if (!this.$v.invoiceForm.$invalid) {
        this.generateInvoice()
      }
    },
    generateInvoice: async function () {
      const payload = {
        invoice: this.getInvoice(),
        stamp: false
      }
      this.overlay = true
      try {
        await this.$api.post(`/v1/charges/income/${this.invoiceForm.category}/invoice`, payload)
        this.$emit('updateOtherInvoices')
        this.closePanel()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    isEmpty,
    deleteConcept (index) {
      this.invoiceForm.concepts.splice(index, 1)
      this.$v.invoiceForm.concepts.$touch()
    },
    editConcept (index) {
      const selectedConcept = this.invoiceForm.concepts[index]
      this.openConceptDialog(selectedConcept, this.billingType)
    },
    allowedDates (val) {
      const topDate = new Date()
      const evalDate = new Date(moment(val).format('YYYY-MM-DDTHH:mm:ss.SSS'))

      return evalDate.getTime() <= topDate.getTime()
    },
    confirmCalendarDates () {
      this.$refs.dateDialog.save(this.invoiceForm.issueDate)
    },
    getUnitName (id) {
      if (this.units) {
        const found = this.units.find(unit => unit._id === id)
        return found ? found.name : undefined
      }
    },
    // Todo: get list of products from api service
    // getProductOrServiceName (id) {
    //   if (this.units) {
    //     const found = this.productOrServices.find(item => item.clave === id)
    //     return found ? found.descripcion : undefined
    //   }
    // },
    resetPanel () {
      this.billingId = null
      this.resetInvoiceForm()
    },
    updateConcepts (updatedConcepts) {
      this.invoiceForm.concepts = [ ...updatedConcepts ]
    },
    async loadNoChargeCategories (params = null) {
      params = params || {
        type: 'income',
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.overlay = true
      try {
        const response = await this.$api.get(`/v1/cashflows`, params)
        this.noChargeCategories = response.data.filter(item =>
          !isEmpty(item.concept) &&
          !isEmpty(item.concept.type) &&
          !item.concept.type.includedInCharges
        )
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    getAddress () {
      const address = []
      const addressData = { ...this.$store.state.currentRestaurant.taxInformation.data.address }

      addressData.street && address.push(addressData.street)
      addressData.exteriorNumber && address.push(addressData.exteriorNumber)
      addressData.interiorNumber && address.push(addressData.interiorNumber)
      addressData.neighborhood && address.push(addressData.neighborhood)
      addressData.locality && address.push(addressData.locality)
      addressData.municipality && address.push(addressData.municipality)
      addressData.state && address.push(addressData.state)
      addressData.country && address.push(addressData.country)
      addressData.zipCode && address.push(addressData.zipCode)

      return address.join(', ')
    },
    getZipCode () {
      return !isEmpty(this.$store.state.currentRestaurant.taxInformation.data.address)
        ? this.$store.state.currentRestaurant.taxInformation.data.address.zipCode
        : ''
    },
    getSubtotal (concept) {
      let total = 0
      const taxRatio = concept.hasTax ? DEFAULT_TAX_RATIO : 0
      if (concept.quantity && concept.unitImport) {
        total = concept.quantity * concept.unitImport

        if (concept.includesTax) {
          total /= (1 + taxRatio)
        }
      }
      return total.toFixed(2)
    },
    getTaxImport (concept) {
      let total = 0
      const taxRatio = concept.hasTax ? DEFAULT_TAX_RATIO : 0

      if (concept.quantity && concept.unitImport) {
        total = concept.quantity * concept.unitImport * taxRatio

        if (concept.includesTax) {
          total /= (1 + taxRatio)
        }
      }
      return Number(total).toFixed(2)
    },
    getTotal (concept) {
      let total = 0
      total = Number(this.getSubtotal(concept)) + Number(this.getTaxImport(concept))
      return total.toFixed(2)
    },
    getInvoice () {
      return {

        customer: {
          legal_name: this.invoiceForm.name,
          tax_id: this.invoiceForm.rfc,
          tax_system: this.invoiceForm.taxRegime,
          address: {
            zip: this.invoiceForm.zipCode
          }
        },
        items: this.invoiceForm.concepts.map(concept => ({
          product: {
            description: concept.description,
            product_key: concept.productOrService,
            price: this.calculatePrice(concept),
            tax_included: concept.hasTax,
            taxes: [{
              rate: DEFAULT_TAX_RATIO,
              type: 'IVA'
            }],
            unit_name: this.getUnitName(concept.unit)
          },
          quantity: concept.quantity,
          discount: 0
        })),
        payment_form: this.invoiceForm.paymentForm,
        type: 'I',
        payment_method: this.invoiceForm.paymentMethod,
        use: this.invoiceForm.cfdiUse,
        currency: 'MXN',
        address: {
          zip: this.invoiceForm.zipCode
        }
      }
    },
    calculatePrice (concept) {
      const taxRatio = concept.addTax ? DEFAULT_TAX_RATIO : 0
      return concept.unitImport * (1 + taxRatio)
    }
  }
}
</script>

<style lang="scss" scoped>
  .content {
    overflow: visible;
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  .titlePanel {
    font-weight: 500;
    font-size: 28px;
    line-height: 33px;
  }

  .blueButton {
    background-color: #0F6FFF !important;
  }

  .table--error {
    & ::v-deep td {
      border-color: var(--v-error-base) !important;
    }
  }

  .textFieldTotal {
    max-width: 120px;

    & ::v-deep input {
      text-align: right;
    }
  }

  .tableConcepts {
    & ::v-deep th {
      padding: 0 8px;
    }

    & ::v-deep td {
      padding: 0 8px;
    }
  }

  .totalBox {
    padding: 8px 16px;
    border: 1px solid #ACABAB;
    border-radius: 13px;
  }

  .gridContainer {
    & ::v-deep .v-text-field__details {
      margin-bottom: 4px;
    }
  }

  .labelWhiteBg {
    & ::v-deep label {
      padding-right: 4px;
      background-color: #fff;
    }
  }
</style>
